// extracted by mini-css-extract-plugin
export default {"wrapper":"PatientFilterChip_wrapper__rFehw","icon":"PatientFilterChip_icon__GMUvs"};